export default __webpack_public_path__ + "fonts/poppins-latin-400-normal.f61407da33b59324fbef.woff";